import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { timer } from 'rxjs';
import { ActionType } from 'src/app/enums/Action-type';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-cards-management',
  templateUrl: './cards-management.component.html',
  styleUrls: ['./cards-management.component.scss']
})
export class CardsManagementComponent implements OnInit {

  isLoading = false;
  selectData: Array<any> = [];
  selectedValue = '1';
  successMsg = '';
  errorMsg = '';
  isCardIssued = false;
  isCardFailed = false;
  isTimeOut = false;
  accountCode = '';
  lang = '';
  propertyId = '';
  reservationId = '';
  subjectId = '';
  intervalItem: any;
  actionType: ActionType = ActionType.ISSUE_GUEST;

  @ViewChild('openModal', { static: true}) openModal: ElementRef<HTMLElement>;
  @ViewChild('closeModal', { static: true}) closeModal: ElementRef<HTMLElement>;

  constructor(
    private dataService: DataService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.selectData = [
      { name: 'Client 1', value: 1},
      { name: 'Client 2', value: 2},
      { name: 'Client 3', value: 3},
      { name: 'Client 4', value: 4},
      { name: 'Client 5', value: 5},
    ];
    this.selectedValue = localStorage.getItem('selectedValue');

    this.activatedRoute.queryParamMap.subscribe(paramMap => {
      this.accountCode = paramMap.get('accountCode');
      this.lang = paramMap.get('lang');
      this.propertyId = paramMap.get('propertyId');
      this.reservationId = paramMap.get('reservationId');
      this.subjectId = paramMap.get('subjectId');
    });

  }

  issueNewGuest() {
    this.actionType = ActionType.ISSUE_GUEST;
    this.isLoading = true;
    this.resetFields();
    this.updateMsg();

    var body = {
      ReservationID: this.reservationId,
      Pcnum: this.selectedValue,
      ActionType: this.actionType,
      Num_of_card_issue: 2,
      Status: 0
    }

    this.dataService.CardChecking(body).subscribe((response: any) => {
      var val = 0;
      this.intervalItem = setInterval(() => {
        ++val;
        if(val >= 5) {
          clearInterval(this.intervalItem);
          this.isTimeOut = true;
          this.isLoading = false;
        }else {
          this.dataService.GetReservationByReservationID(this.reservationId).subscribe((response: any) => {
            
            var status = response.Response.Status;
            if(status > 1) {
              this.resetFields();
              clearInterval(this.intervalItem);
              this.isLoading = false;
              if(status === 2) {
                this.isCardIssued = true;
              }else {
                this.isCardFailed = true;
              }
            }
          });

        }
      }, 3000);

    }, 
    err => {
      this.isLoading = false;
      this.isCardFailed = true;
      if(err.status == 400 && err.error.Code == -1) {
        this.openModal.nativeElement.click();
        this.errorMsg = 'Invalid reservation';
      }
    });
  }

  issueCopyGuest() {
    this.actionType = ActionType.COPY_GUEST;
    this.isLoading = true;
    this.resetFields();
    this.updateMsg();

    var body = {
      ReservationID: this.reservationId,
      Pcnum: this.selectedValue,
      ActionType: this.actionType,
      Num_of_card_issue: 2,
      Status: 0
    }


    this.dataService.CardChecking(body).subscribe((response: any) => {

      var val = 0;
      this.intervalItem = setInterval(() => {
        ++val;
        if(val >= 5) {
          clearInterval(this.intervalItem);
          this.isTimeOut = true;
          this.isLoading = false;
        }
        else {
          this.dataService.GetReservationByReservationID(this.reservationId).subscribe((response: any) => {
            
            var status = response.Response.Status;
            if(status > 1) {
              this.resetFields();
              clearInterval(this.intervalItem);
              this.isLoading = false;
              if(status === 2) {
                this.isCardIssued = true;
              }
              else {
                this.isCardFailed = true;
              }
            }
          });
        }
      }, 3000);

    }, 
    err => {
      this.isLoading = false;
      this.isCardFailed = true;
      if(err.status == 400 && err.error.Code == -1) {
        this.openModal.nativeElement.click();
        this.errorMsg = 'Invalid reservation';
      }
    });
  }

  deleteGuestCard() {
    this.actionType = ActionType.DELETE_CARD;
    this.isLoading = true;
    this.resetFields();
    this.updateMsg();

    var body = {
      ReservationID: this.reservationId,
      Pcnum: this.selectedValue,
      ActionType: this.actionType,
      Num_of_card_issue: 2,
      Status: 0
    }


    this.dataService.CardChecking(body).subscribe((response: any) => {

      var val = 0;
      this.intervalItem = setInterval(() => {
        ++val;
        if(val >= 5) {
          clearInterval(this.intervalItem);
          this.isTimeOut = true;
          this.isLoading = false;
        }else {
          this.dataService.GetReservationByReservationID(this.reservationId).subscribe((response: any) => {
            
            var status = response.Response.Status;
            if(status > 1) {
              this.resetFields();
              clearInterval(this.intervalItem);
              this.isLoading = false;
              if(status === 2) {
                this.isCardIssued = true;
              }else {
                this.isCardFailed = true;
              }
            }
          });
        }
      }, 3000);

    }, 
    err => {
      this.isLoading = false;
      this.isCardFailed = true;
      if(err.status == 400 && err.error.Code == -1) {
        this.openModal.nativeElement.click();
        this.errorMsg = 'Invalid reservation';
      }
    });
  }

  onSelectChange(selectedValue) {
    localStorage.setItem('selectedValue', selectedValue);
    this.selectedValue = selectedValue;
  }


  resetFields() {
    this.isCardIssued = false;
    this.isCardFailed = false;
    this.isTimeOut = false;
  }

  updateMsg() {
    if(this.actionType == ActionType.ISSUE_GUEST) {
      this.successMsg = 'Card Issued';
      this.errorMsg = 'Action Failed';
    }
    else if(this.actionType == ActionType.COPY_GUEST) {
      this.successMsg = 'Card Issued';
      this.errorMsg = 'Action Failed';
    }
    else if (this.actionType == ActionType.DELETE_CARD) {
      this.successMsg = 'Card Deleted';
      this.errorMsg = 'Action Failed';
    }
  }

  ApplyReservation() {
    this.closeModal.nativeElement.click();
  }

}
